"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationSummaryFlightBlock = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const classFunctions_1 = require("../../../../../utils/classFunctions");
const Icon_1 = require("../../../../Icon");
const rateTypeMapper_1 = require("../../../PriceVariant/rateTypeMapper");
const ReservationSummaryFlightBlock = (props) => {
    const { flights } = props;
    if (!flights)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__block` },
        react_1.default.createElement("h4", { className: `${__1.className}__subtitle` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary/SubTitle:Flight', defaultMessage: 'Flight information' })),
        flights.map((flightLeg, idx) => {
            const { EditFlightActionWrapper, rateTariffType } = flightLeg;
            const rateModifier = rateTypeMapper_1.rateTypeToModifierMap[rateTariffType];
            const headerClassNames = (0, classFunctions_1.getClassNames)(`${__1.className}__block-header`, [rateModifier]);
            return (react_1.default.createElement("div", { key: `flightLeg::${flightLeg.flightSummary}:${idx}`, className: headerClassNames },
                react_1.default.createElement("div", { className: `${__1.className}__block-inner` },
                    react_1.default.createElement("div", { className: `${__1.className}__block-inner-content` },
                        react_1.default.createElement("p", null, flightLeg.airportsTitle),
                        react_1.default.createElement("p", null, flightLeg.flightSummary),
                        flightLeg.availableSeats !== undefined && (react_1.default.createElement("p", null,
                            react_1.default.createElement("span", null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary/FlightBlock:FreeSeats', defaultMessage: 'Free seats' }),
                                ":"),
                            "\u00A0",
                            react_1.default.createElement("span", null, flightLeg.availableSeats)))),
                    EditFlightActionWrapper && (react_1.default.createElement(EditFlightActionWrapper, null,
                        react_1.default.createElement("span", { className: `${__1.className}__block-button` },
                            react_1.default.createElement(Icon_1.Icon, { name: 'edit' })))))));
        })));
};
exports.ReservationSummaryFlightBlock = ReservationSummaryFlightBlock;
//# sourceMappingURL=index.js.map